<script setup lang="ts">
    import { ChevronDown } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuLabel,
        DropdownMenuSeparator,
        DropdownMenuTrigger,
    } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { popupCenterDual } from '@/utils/helpers';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';

    const { hasPermission } = usePermissions();

    const props = defineProps<{
        voucher: Voucher;
    }>();

    const download = (fileId: number) => {
        popupCenterDual(
            route(hasPermission(Permission.VOUCHERS_OWN_VIEW) && !hasPermission(Permission.VOUCHERS_VIEW)
                ? 'v2.voucher.own.file.download'
                : 'v2.voucher.file.download',
                { voucherId: props.voucher.id, fileId }),
            props.voucher.VoucherNumber,
            window.innerWidth / 2,
            window.innerHeight / 1.1,
        );
    };
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button
                variant="continue"
                size="xs"
            >
                {{ $t('vouchers.see') }}
                <ChevronDown class="h-4 w-4" />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
            <DropdownMenuItem
                v-for="file in voucher.files_without_data"
                :key="file.id"
                @click="download(file.id)"
                class="max-w-[200px]"
            >
                <span class="w-full truncate">{{ file.original_filename }}</span>
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>
